// react
import React from "react";

import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons";
// dependencies
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// components
import Button from "../../../../../../components/Button";
import InputText from "../../../../../../components/Inputs/InputText";
import UniqueQuestionsTable from "./UniqueQuestionsTable";

// store
import useReportStore from "../../store";

// styles
import css from "./ModalContent.module.scss";
// schema
import { IEditGroupData } from "./schema";

interface BaseProps {
	handleCreateGroup: () => void;
	editGroupData?: IEditGroupData;
	handleEditGroup: () => void;
}

/**
 * Modal to edit or create a question group which renders group name input
 * and create/edit group button, and mounts the UniqueQuestionsTable component
 */
const ModalContent = (props: BaseProps) => {
	const { handleCreateGroup, handleEditGroup } = props;

	const [name, setQuestionGroupModalValue, modalError, groupingQuestionModalState, hasGroupableQuestions] =
		useReportStore((state) => [
			state.questionGroupingModal.name,
			state.questionGroupingModal.setQuestionGroupModalValue,
			state.questionGroupingModal.modalError,
			state.questionGroupingModal.state,
			state.hasGroupableQuestions,
		]);

	return (
		<div className={css.modalContent}>
			<div className={css.modalHeader}>
				{groupingQuestionModalState === "EDIT" ? "Edit " : "Create "}Question Group
			</div>
			{modalError ? (
				<div className={css.errorContainer}>
					<div className={css.exclamationIcon}>
						<FontAwesomeIcon icon={faExclamationCircle} />
					</div>
					<div>{modalError}</div>
				</div>
			) : null}
			<div className={css.inputRow}>
				<div className={css.inputLabel}>Question Group Name:</div>
				<div className={css.groupNameInput}>
					<InputText
						value={name}
						onChange={(value: string) => setQuestionGroupModalValue({ name: value })}
						ariaLabel="Question group name"
					/>
				</div>
			</div>
			<div>
				<div className={css.inputRow}>
					<div className={css.inputLabel}>Add Questions to Group:</div>
				</div>
				<div className={css.createGroupTable}>
					<UniqueQuestionsTable />

					{hasGroupableQuestions ? (
						<div className={css.nextButton}>
							<Button
								size="large"
								style={{ padding: "0 1.5rem" }}
								color="green"
								onClick={groupingQuestionModalState === "EDIT" ? handleEditGroup : handleCreateGroup}
							>
								{groupingQuestionModalState === "EDIT" ? "Save Group" : "Create Group"}
							</Button>
						</div>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default ModalContent;
